// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdClickTrackerController from "./ad_click_tracker_controller"
application.register("ad-click-tracker", AdClickTrackerController)

import AdImageUploadController from "./ad_image_upload_controller"
application.register("ad-image-upload", AdImageUploadController)

import AdSwipeController from "./ad_swipe_controller"
application.register("ad-swipe", AdSwipeController)

import AgeInputController from "./age_input_controller"
application.register("age-input", AgeInputController)

import AdTypeSelectionController from "./ad_type_selection_controller"
application.register("ad-type-selection", AdTypeSelectionController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AddressCopyController from "./address_copy_controller"
application.register("address-copy", AddressCopyController)

import AdminBulkActionsController from "./admin_bulk_actions_controller"
application.register("admin-bulk-actions", AdminBulkActionsController)

import AdminCommandController from "./admin_command_controller"
application.register("admin-command", AdminCommandController)

import AdminConfirmDialogController from "./admin_confirm_dialog_controller"
application.register("admin-confirm-dialog", AdminConfirmDialogController)

import AdminDatatableController from "./admin_datatable_controller"
application.register("admin-datatable", AdminDatatableController)

import AdminDialogController from "./admin_dialog_controller"
application.register("admin-dialog", AdminDialogController)

import AdminDropdownController from "./admin_dropdown_controller"
application.register("admin-dropdown", AdminDropdownController)

import AdminFormDialogController from "./admin_form_dialog_controller"
application.register("admin-form-dialog", AdminFormDialogController)

import AdminIconController from "./admin_icon_controller"
application.register("admin-icon", AdminIconController)

import AdminMessageFormController from "./admin_message_form_controller"
application.register("admin-message-form", AdminMessageFormController)

import AdminSearchFormController from "./admin_search_form_controller"
application.register("admin-search-form", AdminSearchFormController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AdminTargetedMessageController from "./admin_targeted_message_controller"
application.register("admin-targeted-message", AdminTargetedMessageController)

import AdminThemeController from "./admin_theme_controller"
application.register("admin-theme", AdminThemeController)

import AdsTrendChartController from "./ads_trend_chart_controller"
application.register("ads-trend-chart", AdsTrendChartController)

import AdsCategoryRotatorController from "./ads_category_rotator_controller"
application.register("ads-category-rotator", AdsCategoryRotatorController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import BadgeSyncController from "./badge_sync_controller"
application.register("badge-sync", BadgeSyncController)

import BookmarkToastController from "./bookmark_toast_controller"
application.register("bookmark-toast", BookmarkToastController)

import NativeFlashController from "./native_flash_controller"
application.register("native-flash", NativeFlashController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)


import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CategoryRotatorController from "./category_rotator_controller"
application.register("category-rotator", CategoryRotatorController)

import CategoryPickerController from "./category_picker_controller"
application.register("category-picker", CategoryPickerController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatSwipeController from "./chat_swipe_controller"
application.register("chat-swipe", ChatSwipeController)

import ConsentPromptController from "./consent_prompt_controller"
application.register("consent-prompt", ConsentPromptController)

import ConsentToggleController from "./consent_toggle_controller"
application.register("consent-toggle", ConsentToggleController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DashboardCollapsibleController from "./dashboard_collapsible_controller"
application.register("dashboard-collapsible", DashboardCollapsibleController)

import DatetimeSnapController from "./datetime_snap_controller"
application.register("datetime-snap", DatetimeSnapController)

import DeleteConfirmationController from "./delete_confirmation_controller"
application.register("delete-confirmation", DeleteConfirmationController)

import DemoLoginController from "./demo_login_controller"
application.register("demo-login", DemoLoginController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import PreferenceSummaryController from "./preference_summary_controller"
application.register("preference-summary", PreferenceSummaryController)

import RevealMotionController from "./reveal_motion_controller"
application.register("reveal-motion", RevealMotionController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DisabledCtaController from "./disabled_cta_controller"
application.register("disabled-cta", DisabledCtaController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DistrictAutocompleteController from "./district_autocomplete_controller"
application.register("district-autocomplete", DistrictAutocompleteController)

import DistrictTargetingController from "./district_targeting_controller"
application.register("district-targeting", DistrictTargetingController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import FirstVisitPromptController from "./first_visit_prompt_controller"
application.register("first-visit-prompt", FirstVisitPromptController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FloatingFabController from "./floating_fab_controller"
application.register("floating-fab", FloatingFabController)

import FloatingTabbarController from "./floating_tabbar_controller"
application.register("floating-tabbar", FloatingTabbarController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import GpsController from "./gps_controller"
application.register("gps", GpsController)

import GpsTriggerController from "./gps_trigger_controller"
application.register("gps-trigger", GpsTriggerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import KeyboardCoverController from "./keyboard_cover_controller"
application.register("keyboard-cover", KeyboardCoverController)

import KeyboardOffsetController from "./keyboard_offset_controller"
application.register("keyboard-offset", KeyboardOffsetController)

import LandingContactController from "./landing_contact_controller"
application.register("landing-contact", LandingContactController)

import LandingParallaxController from "./landing_parallax_controller"
application.register("landing-parallax", LandingParallaxController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListerTypeController from "./lister_type_controller"
application.register("lister-type", ListerTypeController)

import ListingCompareController from "./listing_compare_controller"
application.register("listing-compare", ListingCompareController)

import ListingWizardController from "./listing_wizard_controller"
application.register("listing-wizard", ListingWizardController)

import LottieAnimationController from "./lottie_animation_controller"
application.register("lottie-animation", LottieAnimationController)

import MotionCueController from "./motion_cue_controller"
application.register("motion-cue", MotionCueController)

import OnboardingIntroController from "./onboarding_intro_controller"
application.register("onboarding-intro", OnboardingIntroController)

import LocationHeroController from "./location_hero_controller"
application.register("location-hero", LocationHeroController)


import LocationVerificationController from "./location_verification_controller"
application.register("location-verification", LocationVerificationController)

import MapPickerController from "./map_picker_controller"
application.register("map-picker", MapPickerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import NativeAuthController from "./native_auth_controller"
application.register("native-auth", NativeAuthController)

import NativeGpsController from "./native_gps_controller"
application.register("native-gps", NativeGpsController)

import NativePushController from "./native_push_controller"
application.register("native-push", NativePushController)

import NativeShareController from "./native_share_controller"
application.register("native-share", NativeShareController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NotificationAutoReadController from "./notification_auto_read_controller"
application.register("notification-auto-read", NotificationAutoReadController)

import NotificationSwipeController from "./notification_swipe_controller"
application.register("notification-swipe", NotificationSwipeController)

import OrgSelectorController from "./org_selector_controller"
application.register("org-selector", OrgSelectorController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import ProductsIndexController from "./products_index_controller"
application.register("products-index", ProductsIndexController)

import ProfileFilterController from "./profile_filter_controller"
application.register("profile-filter", ProfileFilterController)

import ProgressiveImageController from "./progressive_image_controller"
application.register("progressive-image", ProgressiveImageController)

import ProhibitedKeywordsController from "./prohibited_keywords_controller"
application.register("prohibited-keywords", ProhibitedKeywordsController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import RegionMapController from "./region_map_controller"
application.register("region-map", RegionMapController)

import StaticMapController from "./static_map_controller"
application.register("static-map", StaticMapController)

import RejectModalController from "./reject_modal_controller"
application.register("reject-modal", RejectModalController)

import RescueAnimalFormController from "./rescue_animal_form_controller"
application.register("rescue-animal-form", RescueAnimalFormController)

import ReservationHighlightController from "./reservation_highlight_controller"
application.register("reservation-highlight", ReservationHighlightController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ReviewTriggerController from "./review_trigger_controller"
application.register("review-trigger", ReviewTriggerController)

import RippleController from "./ripple_controller"
application.register("ripple", RippleController)

import ScrollFocusController from "./scroll_focus_controller"
application.register("scroll-focus", ScrollFocusController)

import ScrollOverflowController from "./scroll_overflow_controller"
application.register("scroll-overflow", ScrollOverflowController)

import ScrollIndicatorController from "./scroll_indicator_controller"
application.register("scroll-indicator", ScrollIndicatorController)

import SearchAutocompleteController from "./search_autocomplete_controller"
application.register("search-autocomplete", SearchAutocompleteController)

import SearchFiltersController from "./search_filters_controller"
application.register("search-filters", SearchFiltersController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShareModalController from "./share_modal_controller"
application.register("share-modal", ShareModalController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SplashGsapController from "./splash_gsap_controller"
application.register("splash-gsap", SplashGsapController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import TabHistoryController from "./tab_history_controller"
application.register("tab-history", TabHistoryController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TocHighlighterController from "./toc_highlighter_controller"
application.register("toc-highlighter", TocHighlighterController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import UserSearchController from "./user_search_controller"
application.register("user-search", UserSearchController)

import BitmaskCheckboxesController from "./bitmask_checkboxes_controller"
application.register("bitmask-checkboxes", BitmaskCheckboxesController)

import ChatListUpdateController from "./chat_list_update_controller"
application.register("chat-list-update", ChatListUpdateController)

import WizardStepController from "./wizard_step_controller"
application.register("wizard-step", WizardStepController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import WizardLiveCardController from "./wizard_live_card_controller"
application.register("wizard-live-card", WizardLiveCardController)

import PublishGateController from "./publish_gate_controller"
application.register("publish-gate", PublishGateController)

import HowtoStoryController from "./howto_story_controller"
application.register("howto-story", HowtoStoryController)

import HowtoLaunchController from "./howto_launch_controller"
application.register("howto-launch", HowtoLaunchController)

import HelpSearchController from "./help_search_controller"
application.register("help-search", HelpSearchController)

import AdMetricFocusController from "./ad_metric_focus_controller"
application.register("ad-metric-focus", AdMetricFocusController)

import AdPlanPickerController from "./ad_plan_picker_controller"
application.register("ad-plan-picker", AdPlanPickerController)

import CoachmarkController from "./coachmark_controller"
import SigninGhostController from "./signin_ghost_controller"
application.register("signin-ghost", SigninGhostController)
import HelpTopicsController from "./help_topics_controller"
application.register("help-topics", HelpTopicsController)
application.register("coachmark", CoachmarkController)

import AppUpdatePromptController from "./app_update_prompt_controller"
application.register("app-update-prompt", AppUpdatePromptController)
